import { memo, useCallback, useMemo } from "react";
import Grid from "components/primitives/Grid";
import Tables from "components/Tables";
import useAthleteStore from "providers/AthletesProvider/useAthleteStore";
import { useRequest } from "hooks";
import useAthleteActions from "providers/AthletesProvider/useAthleteActions";
import { useMultiSelectIds } from "providers/MultiSelectProvider";
import CanDoAction from "components/CanDoAction/CanDoAction";
import AthleteBulkDeleteControl from "./AthleteBulkDeleteControl";

interface AthleteTableBulkActionsProps {
  config: {
    showDeleteAthleteAction?: boolean;
  };
}

function AthleteTableBulkActions(props: AthleteTableBulkActionsProps) {
  const selectedItemIds = useMultiSelectIds();
  const athletes = useAthleteStore();

  const visibleSelectedItemIds = useMemo(
    () => athletes.filter((athlete) => selectedItemIds.includes(athlete.id)).map((athlete) => athlete.id),
    [selectedItemIds, athletes]
  );
  const athleteActions = useAthleteActions();
  const archiveAthlete = useRequest(athleteActions.toggleArchived);
  const onArchive = useCallback((athleteId: string) => archiveAthlete(athleteId, true), [archiveAthlete]);

  return (
    <>
      <Grid {...Tables.controlCells.standard}>
        <Tables.Components.BulkArchiveControl onArchive={onArchive} ids={visibleSelectedItemIds} />
      </Grid>
      {props.config.showDeleteAthleteAction ? (
        <CanDoAction action="athlete.delete">
          <Grid {...Tables.controlCells.standard}>
            <AthleteBulkDeleteControl ids={visibleSelectedItemIds} />
          </Grid>
        </CanDoAction>
      ) : null}
    </>
  );
}

export default memo(AthleteTableBulkActions);
